/* Giftera – selectorul „Model lănțișor” (portat din tema live, 24 sep 2026).
   Închis: un rând curat (poză + nume). La apăsare: panou cu poze mari
   (mobil = foaie de jos, 2 pe rând; desktop = fereastră, 4 pe rând).
   Ținta: input[data-gf-value] = proprietatea „Model lănțișor” pe linia din coș
          input[data-gf-code]  = proprietatea ascunsă „_Cod lănțișor” (N01…N13).
   Evenimentul `change` (bubbling) pe input[data-gf-value] și metoda publică choose(tile) sunt
   folosite de rândul „N modele, același preț”, de galerie și de bara lipicioasă. */
(function () {
  if (customElements.get('gf-model-picker')) return;

  var LOCK = 'gf-mp-lock';

  class GfModelPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.toggle = this.querySelector('.gf-mp__toggle');
      this.dialog = this.querySelector('.gf-mp__dialog');
      this.input = this.querySelector('input[data-gf-value]');
      this.codeInput = this.querySelector('input[data-gf-code]');
      this.tiles = Array.from(this.querySelectorAll('.gf-mp__tile'));
      if (!this.toggle || !this.dialog || !this.input || !this.tiles.length) return;
      this._ready = true;

      var self = this;
      var preload = function () { self.preload(); };
      this.toggle.addEventListener('pointerenter', preload, { once: true });
      this.toggle.addEventListener('focus', preload, { once: true });
      this.toggle.addEventListener('touchstart', preload, { once: true, passive: true });
      this.toggle.addEventListener('click', function (e) { e.preventDefault(); self.open(); });

      var closeBtn = this.dialog.querySelector('.gf-mp__close');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      // clic pe fundal (în afara foii) = închide
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      this.dialog.addEventListener('close', function () { self.onClosed(); });
      this.dialog.addEventListener('keydown', function (e) { self.onKeydown(e); });
      this.tiles.forEach(function (t) {
        t.addEventListener('click', function () { self.choose(t); });
      });
    }

    preload() {
      this.dialog.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    selected() {
      return this.tiles.find(function (t) { return t.getAttribute('aria-checked') === 'true'; }) || this.tiles[0];
    }

    open() {
      if (this.dialog.open) return;
      this.preload();
      document.documentElement.classList.add(LOCK);
      this.dialog.classList.remove('is-closing');
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      var cur = this.selected();
      requestAnimationFrame(function () {
        cur.focus({ preventScroll: true });
        cur.scrollIntoView({ block: 'nearest' });
      });
    }

    close() {
      var d = this.dialog, self = this;
      if (!d.open || d.classList.contains('is-closing')) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      d.classList.add('is-closing');
      setTimeout(function () {
        d.classList.remove('is-closing');
        if (typeof d.close === 'function') d.close();
        else { d.removeAttribute('open'); self.onClosed(); }
      }, reduce ? 0 : 200);
    }

    onClosed() {
      document.documentElement.classList.remove(LOCK);
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.focus({ preventScroll: true });
    }

    choose(tile) {
      var value = tile.dataset.value;
      this.tiles.forEach(function (t) {
        var on = t === tile;
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      var label = this.toggle.querySelector('.gf-mp__label');
      if (label) label.textContent = value;
      var img = this.toggle.querySelector('.gf-mp__thumb img');
      if (img && tile.dataset.thumb) img.src = tile.dataset.thumb;
      if (this.codeInput) this.codeInput.value = tile.dataset.code || '';
      if (this.input.value !== value) {
        this.input.value = value;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var self = this;
      setTimeout(function () { self.close(); }, 160);
    }

    columns() {
      var grid = this.dialog.querySelector('.gf-mp__grid');
      var cols = grid ? getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length : 2;
      return cols || 2;
    }

    onKeydown(e) {
      var idx = this.tiles.indexOf(document.activeElement);
      if (idx < 0) return;
      var n = this.tiles.length, next = -1, cols = this.columns();
      switch (e.key) {
        case 'ArrowRight': next = Math.min(idx + 1, n - 1); break;
        case 'ArrowLeft': next = Math.max(idx - 1, 0); break;
        case 'ArrowDown': next = Math.min(idx + cols, n - 1); break;
        case 'ArrowUp': next = Math.max(idx - cols, 0); break;
        case 'Home': next = 0; break;
        case 'End': next = n - 1; break;
        default: return;
      }
      e.preventDefault();
      this.tiles[next].focus();
    }
  }

  customElements.define('gf-model-picker', GfModelPicker);
})();
